import React, { Component, Fragment } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as Cx from 'cx-js-sdk';
import { LoadingSpinnerSVG, Logo, LanguagePicker, Toast } from 'cx-ui-components';
import Select from '../../components/Select';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { mappedLocalesOptions } from '../../i18n';
import { cxInit, versionCheck, cxSetTenant, cxLogin, cxTokenLogin } from '../../utils/cxSdk';
import { urlParamsToObj, removeAuthParams, msOauthParamsToObj } from '../../utils/url';
import { customSortStringMethod, setTenantOptionStyle, requiresReAuth } from "../../utils/index";
import PrivacyPolicy from '../Legal/privacyPolicy';
import LegalPolicy from '../Legal/legalPolicy';
import messages from './messages';
import store from '../../redux/store';
import { unsetSelectedEntityId } from '../../redux/modules/entities';

const Loading = styled(LoadingSpinnerSVG)`
  top: 150px;
  top: calc(50% - ${(props) => props.size / 2}px);
  left: calc(50% - ${(props) => props.size / 2}px);
`;

const TempBackground = styled.div`
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  background-repeat: repeat;
  background-image: url('https://qe-config.cxengagelabs.net/assets/images/square_bg.png'),
    linear-gradient(to bottom, #0a64aa, #3498db);
  z-index: -1;
`;

const SignInTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  color: rgb(73, 73, 73);
  display: block;
  text-align: center;
  margin: 30px 0px;
`;

const LoginFormWrapper = styled.div`
  position: relative;
  top: 70px;
`;

const LoginBox = styled.div`
  width: 540px;
  height: 560px;
  margin: 0px auto;
  margin-top: calc(50vh - 270px);
  border-radius: 3px;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.09) 0px 0px 6px 0px;
  position: relative;
  z-index: 1;
`;

const LoginInput = styled.input`
  width: 282px;
  height: 44px;
  background-color: rgb(255, 255, 255);
  font-size: 16px;
  font-style: normal;
  font-stretch: normal;
  color: rgb(73, 73, 73);
  outline: none;
  padding: 0px 11px;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(151, 151, 151);
  margin-bottom: 10px;
  display: block;
  margin: 10px auto;
`;

const LoginButton = styled.button`
  border-radius: 8px;
  border-width: 0px;
  background-color: rgb(35, 205, 244);
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  color: rgb(255, 255, 255);
  padding: 14px 28px;
  cursor: pointer;
  outline: none;
  display: block;
  margin: 10px auto;
`;

const Preferences = styled.div`
  display: block;
  width: 242px;
  margin: 0px auto;
`;

const Checkbox = styled.input`
  margin-left: -15px;
  margin-right: 10px;
  margin-top: 5px;
`;

const CheckboxLabel = styled.label`
  vertical-align: middle;
  color: rgb(73, 73, 73);
  font-size: 16px;
`;

const StyledLanguagePicker = styled(LanguagePicker)`
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 1.5em;
`;

const ForgotPassword = styled.div`
  text-align: center;
`;

const SignInSSOMessage = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  color: rgb(73, 73, 73);
  text-align: center;
  padding-bottom: 23px;
`;

const storage = window.localStorage;

const styles = {
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
  },
  mainContainer: {
    padding: '0 50px',
    height: '100%',
    display: 'grid',
    gridTemplateRows: '1fr 2.5fr',
    justifyContent: 'center',
  },
};
//function to check if authentication token is expired or not....
export const isTokenExpired = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return true;
  }

  const jwtPayload = JSON.parse(window.atob(token.split('.')[1]))
  const tokenIsExpired = jwtPayload && (jwtPayload.exp * 1000 < Date.now());

  if (tokenIsExpired) {
    window.localStorage.clear();
    store.dispatch({type: 'RESET_APP'});
  }

  return tokenIsExpired;
 };

export class Login extends Component {
  constructor() {
    super();
    this.state = {
      authInfo: null,
      identityWindowSuccessful: false,
      loading: false,
      loginPreferences: (storage.getItem('loginPreferences') && JSON.parse(storage.getItem('loginPreferences'))) || {},
      password: '',
      platformViewOnlyCapable: false,
      rememberSsoEmail: storage.getItem('rememberSsoEmail') === 'true',
      sdkLoaded: false,
      selectedTenant: null,
      ssoEmail: storage.getItem('ssoEmail') || '',
      ssoPopupBlocked: false,
      tenantId: '-1',
      username: this.rememberedEmail(),
    };
  }

  componentDidMount() {
    cxInit();

    // validate if page has loaded completely
    addEventListener('load', this.handleLoadEvent);
  }

  componentWillUnmount() {
    clearInterval(versionCheck);
    removeEventListener('load', this.handleLoadEvent);
    window.removeEventListener('message', this.handleMessageEvent);
    store.dispatch(unsetSelectedEntityId());
  }

  componentWillMount() {
    // validate if MS OAuth parameters exists in the url and send it to parent window
    const msOauthParams = msOauthParamsToObj();
    if (msOauthParams && (msOauthParams.code || msOauthParams.error)) {
      window.opener.postMessage(msOauthParams, window.location.origin);
      window.close();
    } else {
      if (CxEngage.version && !this.state.sdkLoaded) {
        this.setState({ sdkLoaded: true });
      }

      // set SSO-triggering query params
      this.setAuthProperties();
    }
  }

  handleLoadEvent = () => {
    // constantly check if sdk has finished initialization
    window.addEventListener('message', this.handleMessageEvent);
  };

  handleMessageEvent = () => {
    if (CxEngage.version && !this.state.sdkLoaded) {
      this.setState({ sdkLoaded: true });

      // if any of the SSO-triggering query params are present, let's do SSO
      if (CxEngage.version) {
        if (this.areParamsPresent() && window.location.hash.indexOf('login') > 0) {
          return;
        }
        if (this.areParamsPresent() && (this.state.authInfo || this.state.loginPreferences.sso)) {
          this.loginWithSso();
        }
      }
    }
  };

  rememberedEmail() {
    if (storage.getItem('loginPreferences')) {
      const prefs = JSON.parse(storage.getItem('loginPreferences'));
      if (prefs.remember) {
        return storage.getItem('email');
      } else {
        return '';
      }
    } else {
      return '';
    }
  };

  setSsoEmail = (ssoEmail) => {
    this.setState({ ssoEmail });
    storage.setItem('ssoEmail', ssoEmail);
  };

  setRememberSsoEmail = (rememberSsoEmail) => {
    this.setState({ rememberSsoEmail });
    storage.setItem('rememberSsoEmail', rememberSsoEmail);
  };

  setAuthProperties = () => {
    // if we are not logging in via url params, then return
    if (!this.areParamsPresent()) {
      return;
    }

    const urlParamsObj = urlParamsToObj();
    // the auth params object is the argument we'll need to
    // pass into CxEngage.authentication.getAuthInfo
    let authParams = {};
    if (urlParamsObj.tenantId) {
      authParams = {
        tenantId: urlParamsObj.tenantId,
      };
      this.setState({
        tenantId: urlParamsObj.tenantId,
      });
    } else if (urlParamsObj.tenantid) {
      authParams = {
        tenantId: urlParamsObj.tenantid,
      };
      this.setState({
        tenantId: urlParamsObj.tenantid,
      });
    } else if (urlParamsObj.tenantid && urlParamsObj.idp) {
      authParams = {
        tenantId: urlParamsObj.tenantid,
        idpId: urlParamsObj.idp,
      };
      this.setState({
        tenantId: urlParamsObj.tenantid,
      });
    } else if (urlParamsObj.username) {
      authParams = {
        username: urlParamsObj.username,
      };
    }

    this.setState({
      authInfo: authParams,
    });
  }

  setUsername = (e) => {
    this.setState({ username: e.target.value });
  };

  setPassword = (e) => {
    this.setState({ password: e.target.value });
  };

  setSelectedTenant = (tenantId, tenantName, requiresReAuth) => {
    this.props.switchTenant(tenantId);
    this.setState({
      tenantId,
      selectedTenant: {
        tenantName,
        tenantId,
        requiresReAuth
      }
    });
  };

  chooseTenant = () => {
    if (this.state.selectedTenant && this.state.selectedTenant.tenantId !== '-1') {
      const selectingTenant = this.props.availableTenants.find(
        (tenant) => tenant.tenantId === this.state.tenantId
      );

      // if this tenant is not available to use without reAuth,
      // store the tenant we will be logging into, and refresh the page
      if (this.state.selectedTenant.requiresReAuth) {
        if (selectingTenant.password && selectingTenant.identityProviders.length === 0) {
          this.setLoginPreferences('sso', false);
          this.setSelectedTenant('', '', false);
          this.props.setUserAuthed(false);
          return;
        } else {
          this.setLoginPreferences('sso', true);
          window.history.pushState(
            '',
            document.title,
            `${window.location.pathname}${
              window.location.search ? `${window.location.search}&` : '?'
            }tenantid=${selectingTenant.tenantId}${window.location.hash}`
          );
          window.location.reload();
          return;
        }
      }

      if (selectingTenant) {
        cxSetTenant(selectingTenant.tenantId, (response) => {
          if (response && response.tenantId) {
            this.props.switchTenant(response.tenantId);
            this.props.fetchBranding();
            // Clean platform from login preference after successfully logging in
            const { platform, ...Preferences } = this.state.loginPreferences;
            storage.setItem('loginPreferences', JSON.stringify(Preferences));
          }
        });
        //set the selected tenant to the localstorage for browser access..
        localStorage.setItem("tenant", selectingTenant.tenantId);
      }
    }
    this.setState({
      loading: false,
      username: '',
      password: ''
    });
  };

  fetchAllTenants() {
    let self = this;
    Cx.reuseToken({ token: sessionStorage.getItem('token') });
    Cx.regions().then((d) =>
      Cx.allTenants(d[0].id).then((d) => {
        const updatedTenantList = d
          .filter((tenant) => tenant.active)
          .map((tenant) => ({
            value: tenant.tenantId,
            label: tenant.name,
            style: setTenantOptionStyle(self.state.loginPreferences.sso, tenant, self.props.availableTenants, self.props.accountTenants),
            className: 'account-tenant',
            requiresReAuth: requiresReAuth(self.state.loginPreferences.sso, tenant, self.props.availableTenants, self.props.accountTenants),
            title: requiresReAuth(self.state.loginPreferences.sso, tenant, self.props.availableTenants, self.props.accountTenants)
              ? self.props.intl.formatMessage(messages.selectTenantReAuthTitle)
              : '',
          }));
        self.props.setTenantsList(updatedTenantList);
      })
    );
  }

  onEnterKey = ({ key }) => (key === 'Enter' ? this.login() : undefined);

  loginPreferences = ({ target: { name, checked } }) => {
    if (name === 'platform' && checked) {
      this.fetchAllTenants();
    }

    this.setLoginPreferences(name, checked);
  };

  setLoginPreferences = (name, checked) => {
    const Preferences = {
      ...this.state.loginPreferences,
      [name]: checked,
    };
    this.setState({ loginPreferences: Preferences });
    storage.setItem('loginPreferences', JSON.stringify(Preferences));
  };

  onLogin = () => {
    this.setState({ loading: true });
    this.useDebugTokenExpiration();

    let username;
    if (this.isReauthFromExpiredSession()) {
      username = this.state.expiredSessionReauth.expiredSessionUsername;
    } else {
      username = this.state.email.trim();
    }
    this.setState({ username });
  };

  login = (token) => {
    if (!this.state.username || !this.state.password) {
      Toast.error(this.props.intl.formatMessage(messages.error));
      return;
    }

    if (CxEngage.version) {
      this.setState({ loading: true });
      if (token) {
        cxTokenLogin(token, (response) => {
          this.handleLoginResponse(response);
        });
      } else {
        if (this.state.loginPreferences.remember) {
          storage.setItem('email', this.state.username);
        } else {
          storage.setItem('email', '');
        }
        cxLogin(this.state.username, this.state.password, (response) => {
          this.handleLoginResponse(response);
        });
      }
    } else {
      Toast.info(this.props.intl.formatMessage(messages.loadingSdk));
    }
  };

  loginWithSso = () => {
    // try not to open the window popup and show error when username field is empty
    if ((!this.areParamsPresent() && !this.state.username) || (this.state.username && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.state.username))) {
      Toast.error(this.props.intl.formatMessage(messages.errorEmail));
      return;
    }

    const authInfoParams = this.state.authInfo ? this.state.authInfo
      : {
        username: this.state.username
      };
    if (this.state.ssoPopupBlocked) {
      this.setState({ ssoPopupBlocked: false });
    }
    this.useDebugTokenExpiration();

    // We have to open this window in the onClick handler to prevent it from being a blocked popup
    // SDK proceeds uses this window with the name "cxengageSsoWindow"
    const ssoWindow = window.open(
      '',
      'cxengageSsoWindow',
      'width=500,height=500'
    );

    if (!ssoWindow || ssoWindow.closed || typeof ssoWindow.closed === 'undefined') {
      this.setState({
        ssoPopupBlocked: true,
        loading: false
      });
    }
    else {
      let authSubId;
      let self = this;
      if (CxEngage.version) {
        this.setState({ loading: true });
        CxEngage.authentication.getAuthInfo(authInfoParams, (error) => {
          if (!error) {
            CxEngage.authentication.popIdentityPage();
          } else {
            const errorMessage = error.message ? error.message : messages.errorUnexpected;
            Toast.error(errorMessage);
            ssoWindow.close();
            self.setState({ loading: false });
          }
        });

        if (CxEngage.subscribe) {
          authSubId = CxEngage.subscribe('cxengage/authentication',
            function (authError, authTopic, authResponse) {
              if (!authError) {
                switch (authTopic) {
                  case 'cxengage/authentication/cognito-auth-response': {
                    if (authResponse) {
                      self.setState({ identityWindowSuccessful: true });
                      CxEngage.unsubscribe(authSubId);
                      cxTokenLogin(authResponse, (response) => {
                        self.handleLoginResponse(response);
                      });
                    }
                    break;
                  }
                  case 'cxengage/authentication/identity-window-response': {
                    // identityWindowSuccessful
                    // false = agent closed the window
                    // true = the window was closed due to a successful auth
                    if (!self.state.identityWindowSuccessful || authResponse === true) {
                      self.setState({ loading: false });
                    }
                    break;
                  }
                  default: {
                    // Do Nothing
                    break;
                  }
                }
              }
            }
          );
        }
      } else {
        Toast.info(this.props.intl.formatMessage(messages.loadingSdk));
      }
    }
  };

  handleLoginResponse = (response) => {
    if (response.code && (response.code === 3002 || response.code === 3000)) {
      let errorMessage = response.message ? response.message : this.props.intl.formatMessage(messages.errorUnexpected);
      if (response.data && response.data.apiResponse && response.data.apiResponse.status === 401) {
        errorMessage = this.props.intl.formatMessage(messages.error);
      }
      Toast.error(errorMessage);
      this.setState({ loading: false });
    } else {
      let defaultTenantObject;
      const { defaultTenant, tenants, platformPermissions, userId } = response;
      this.props.setAccountTenants(tenants);
      // Users do not have a 'default tenant' by default
      if (defaultTenant) {
        defaultTenantObject = response.tenants.filter((tenant) => tenant.tenantId === response.defaultTenant)[0];
      }
      if (!defaultTenantObject) {
        defaultTenantObject = response.tenants[0];
      }

      if (this.state.authInfo && this.state.authInfo.tenantId) {
        defaultTenantObject = response.tenants.filter((tenant) => tenant.tenantId === this.state.authInfo.tenantId)[0];
      }
      this.setState({ tenantId: defaultTenantObject.tenantId });

      let self = this;
      CxEngage.session.getTenantDetails((sessionError, sessionTopic, sessionResponse) => {
        if (sessionError) {
          const errorMessage = sessionError.message ? sessionError.message : self.props.intl.formatMessage(messages.errorUnexpected);
          Toast.error(errorMessage);
          self.setState({ loading: false });
        } else {
          switch (sessionTopic) {
            case 'cxengage/session/get-tenant-details': {
              if (sessionResponse) {
                sessionResponse.details.sort((a, b) => {
                  return customSortStringMethod(a.name, b.name);
                });
                if (sessionResponse.details.length) {
                  self.props.setUserTenants(sessionResponse.details);
                  // get everything but the selected item
                  const tenantOptions = sessionResponse.details
                    .filter((tenant) => tenant.active)
                    .map((tenant) => ({
                      value: tenant.tenantId,
                      label: tenant.name,
                      style: setTenantOptionStyle(self.state.loginPreferences.sso, tenant, self.props.availableTenants, self.props.accountTenants),
                      className: 'account-tenant',
                      requiresReAuth: requiresReAuth(self.state.loginPreferences.sso, tenant, self.props.availableTenants, self.props.accountTenants),
                      title: requiresReAuth(self.state.loginPreferences.sso, tenant, self.props.availableTenants, self.props.accountTenants)
                        ? self.props.intl.formatMessage(messages.selectTenantReAuthTitle)
                        : '',
                    }));
                  self.props.setTenantsList(tenantOptions);
                }
                if (self.state.authInfo && self.props.accountTenants) {
                  removeAuthParams();
                  self.props.setUserAuthed(true);
                  self.chooseTenant();
                }
              }
              break;
            }
            default: {
              // Do Nothing
              break;
            }
          }
        }
      });

      sessionStorage.setItem('token', CxEngage.dumpState().authentication.token);
      sessionStorage.setItem('defaultTenant', defaultTenant);
      const isPlatformViewCapable = platformPermissions.includes('PLATFORM_VIEW_ALL_TENANTS');
      //set token and userId to the localstorage for browser access...
      localStorage.setItem("token", CxEngage.dumpState().authentication.token);
      localStorage.setItem("userId", userId);
      localStorage.setItem("tenant", defaultTenant);

      this.props.updateUserPermissions(
        defaultTenantObject.tenantId,
        defaultTenantObject.tenantName,
        defaultTenantObject.tenantPermissions,
        userId
      );
      this.props.updatePlatformPermissions(platformPermissions);

      this.setState({
        selectedTenant: {
          tenantName: defaultTenantObject.tenantName,
          tenantId: defaultTenantObject.tenantId,
          requiresReAuth: false
        },
        platformViewOnlyCapable: isPlatformViewCapable,
        loading: false
      });

      if (this.state.platformViewOnlyCapable) {
        this.props.setUserAuthed(true);
      } else {
        this.props.setUserAuthed(true);
        this.chooseTenant();
      }
    }
  };

  areParamsPresent = () => {
    const urlParamsObj = urlParamsToObj();
    // check to see if any of the SSO-triggering query params are present
    return (
      Object.keys(urlParamsObj).length &&
      (urlParamsObj.username ||
        urlParamsObj.tenantid ||
        urlParamsObj.idp ||
        urlParamsObj.tenantididp)
    );
  };

  isReauthFromExpiredSession = () => {
    this.state.expiredSessionReauth.expiredSessionUsername &&
    this.state.expiredSessionReauth.expiredSessionUsername.length
  };

  useDebugTokenExpiration = () => {
    if (URLSearchParams) {
      const params = new URLSearchParams(window.location.search);
      if (params.has('debugToken')) {
        storage.setItem('debugTokenVal', params.get('debugToken'));
      } else {
        storage.removeItem('debugTokenVal');
      }
    }
  };

  getLoadingContent = () => (
    <div id="loginContainerDiv">
      <div style={styles.contentContainer}>
        <Loading size={120} />
      </div>
    </div>
  );

  getLoginContent = () => {
    return (
      <div>
        {this.state.loginPreferences.sso && (
          <Fragment>
            <SignInTitle>
              <FormattedMessage {...messages.signInWithSso} />
            </SignInTitle>
            <SignInSSOMessage>
              <FormattedMessage
                {...messages.ssoSignInDescription}
              />
            </SignInSSOMessage>
          </Fragment>
        )}
        {!this.state.loginPreferences.sso && (
          <SignInTitle>
            <FormattedMessage {...messages.welcomeMessage} />
          </SignInTitle>
        )}
        <LoginInput
          data-automation="email"
          placeholder={this.props.intl.formatMessage(messages.email)}
          type="email"
          onChange={this.setUsername}
          value={this.state.username}
        />
        {!this.state.loginPreferences.sso && (
          <LoginInput
            data-automation="password"
            placeholder={this.props.intl.formatMessage(messages.password)}
            type="password"
            onChange={this.setPassword}
            value={this.state.password}
            onKeyDown={this.onEnterKey}
            enter={this.onLogin}
          />
        )}
        <Preferences>
          <Checkbox
            type="checkbox"
            data-automation="remember"
            name="remember"
            onChange={this.loginPreferences}
            checked={this.state.loginPreferences && this.state.loginPreferences.remember}
          />
          <CheckboxLabel htmlFor="remember">
            <FormattedMessage {...messages.rememberMe} />
          </CheckboxLabel>{' '}
          <br />
          <Checkbox
            type="checkbox"
            data-automation="sso"
            name="sso"
            onChange={this.loginPreferences}
            checked={this.state.loginPreferences && this.state.loginPreferences.sso}
          />
          <CheckboxLabel htmlFor="sso">
            <FormattedMessage {...messages.signInWithSso} />
          </CheckboxLabel>{' '}
          <br />
        </Preferences>
        {!this.state.loginPreferences.sso && (
          <LoginButton data-automation="signInButton" onClick={() => this.login()}>
            <FormattedMessage {...messages.signIn} />
          </LoginButton>
        )}
        {this.state.loginPreferences.sso && (
          <LoginButton data-automation="signInButtonSso" onClick={() => this.loginWithSso()}>
            <FormattedMessage {...messages.nextButton} />
          </LoginButton>
        )}
      </div>
    );
  };

  getLoggedInContent = () => {
    return (
      <div style={styles.contentContainer}>
        <SignInTitle>
          <FormattedMessage {...messages.selectTenant} />
        </SignInTitle>
        <Select
          data-automation="chooseTenantInput"
          id="selectTenant"
          style={{ width: '282px' }}
          value={this.state.tenantId}
          onChange={(e) => this.setSelectedTenant(e.value || '-1', e.label || '', e.requiresReAuth || false)}
          options={this.props.tenantsList}
          noSuggestionsMessage={this.props.intl.formatMessage({
            id: 'login.noTenantOption',
            defaultMessage: 'No options',
          })}
          autoFocus
          clearable={false}
          placeholder={<FormattedMessage {...messages.selectTenantMenu} />}
        />
        {!this.state.loginPreferences.sso && (
          <Preferences>
            <br />
            <Checkbox
              type="checkbox"
              data-automation="platformAdminModeCheckbox"
              name="platform"
              onChange={this.loginPreferences}
              checked={this.state.loginPreferences && this.state.loginPreferences.platform}
            />
            <CheckboxLabel htmlFor="platform">
              <FormattedMessage {...messages.platformViewMode} />
            </CheckboxLabel>{' '}
            <br />
          </Preferences>
        )}
        <LoginButton
          data-automation="selectTenantButton"
          disabled={!this.state.selectedTenant}
          onClick={this.chooseTenant}>
          <FormattedMessage {...messages.selectButton} />
        </LoginButton>
      </div>
    );
  };

  forgotPassword = () => {
    return (
      <ForgotPassword>
        <Link to="/forgot-password"><FormattedMessage {...messages.passwordForgot} /></Link>
      </ForgotPassword>
    )
  };

  languagePicker = () => {
    return (
      <StyledLanguagePicker
        color="#fff"
        onLanguageChange={this.changeLocale}
        selectedLocale={this.props.locale}
        languageOptions={mappedLocalesOptions}
      />
    )
  };

  toggleLanguageMenu = () => {
    this.setState((prevState) => ({ showLanguage: !prevState.showLanguage }));
  };

  //render method
  render() {
    let pageContent;
    let languageInfo;
    if (!this.props.insideIframe && !this.props.hasStarted || isTokenExpired()) {
      if(!this.props.authenticated) {
        pageContent = this.getLoginContent();
      }
      if(this.props.authenticated) {
        pageContent = this.getLoggedInContent();
      }

      if (isTokenExpired()) {
        pageContent = this.getLoginContent();
      }

      languageInfo = (location.hash.includes('alpha')) ? this.languagePicker() : '';
      return (
        <Fragment>
          <LoginBox>
            <LoginFormWrapper>
              <Logo />
              {!this.state.loading && (
                pageContent
              )}
              {(!this.state.loading && !this.state.loginPreferences.sso && !this.props.authenticated) && (
                this.forgotPassword()
              )}
              {this.state.loading && (
                this.getLoadingContent()
              )}
            </LoginFormWrapper>
          </LoginBox>
          {languageInfo}
          <LegalPolicy />
          <PrivacyPolicy />
          <TempBackground />
        </Fragment>
      );
    } else if (!this.props.insideIframe && this.props.hasStarted && this.props.usermenuPermission) {
      return <Redirect to="/configuration/users" />;
    }
    else {
      return <Redirect to="/userProfile" />;
    }

  }
}

Login.propTypes = {
  accountTenants: PropTypes.any,
  availableTenants: PropTypes.any,
  authenticated: PropTypes.bool.isRequired,
  changeLocale: PropTypes.func.isRequired,
  displayState: PropTypes.any,
  fetchBranding: PropTypes.func.isRequired,
  hasStarted: PropTypes.bool.isRequired,
  initiatedStandalonePopup: PropTypes.bool,
  insideIframe: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  logged_in: PropTypes.bool,
  setAccountTenants: PropTypes.func.isRequired,
  setTenantsList: PropTypes.func.isRequired,
  setUserAuthed: PropTypes.func.isRequired,
  setUserTenants: PropTypes.func.isRequired,
  switchTenant: PropTypes.func.isRequired,
  tenantsList: PropTypes.any,
  updatePlatformPermissions: PropTypes.func,
  updateUserPermissions: PropTypes.func.isRequired,
};

export default injectIntl(connect(null)(Login));
